
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.2 17.54a.926.926 0 001.6 0l8.033-12.81a1.117 1.117 0 00.032-1.12l-1.7-3.1a.953.953 0 00-.832-.51H2.666a.954.954 0 00-.83.512l-1.7 3.1a1.118 1.118 0 00.031 1.12L8.2 17.54zM7.98 3.136h7.284l.535.973-.7 1.118H7.98a1.046 1.046 0 010-2.091zm-5.244 0H3.9a1.046 1.046 0 010 2.09h-1L2.2 4.11l.536-.973z","fill":"#F8BF13"}})])
          )
        }
      }
    